import { useState, FormEvent } from 'react';
import { login } from '../auth';

interface Props {
  onLoggedIn: () => void;
}

export function LoginForm({ onLoggedIn }: Props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<{ msg: string; code?: string } | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!username.trim() || password.length < 8) {
      setErr({ msg: 'username required + password ≥ 8 chars' });
      return;
    }
    setErr(null);
    setBusy(true);
    const res = await login(username.trim(), password);
    setBusy(false);
    if (res.ok) {
      setPassword('');
      onLoggedIn();
      return;
    }
    setErr({ msg: res.error, code: res.code });
  };

  const codeHint = (code?: string): string | null => {
    if (!code) return null;
    if (code === 'AUTH_UNAVAILABLE') return 'Backend crypto not ready (dev-mode 503).';
    if (code === 'AUTH_INVALID')     return 'Wrong username or password.';
    if (code === 'AUTH_BAD_REQUEST') return 'Request rejected — check field values.';
    return null;
  };

  return (
    <section className="view login">
      <h2>Sign in</h2>
      <p className="muted">
        tantrazAlA authentication. Access token stored per-tab
        (sessionStorage); closes with the tab.
      </p>

      <form onSubmit={onSubmit} className="login-form">
        <label>
          Username
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
            disabled={busy}
          />
        </label>

        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            minLength={8}
            required
            disabled={busy}
          />
        </label>

        <button type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        {err && (
          <div className="err login-err">
            <p><strong>Error:</strong> {err.msg}</p>
            {err.code && (
              <p className="muted mono">code: {err.code}</p>
            )}
            {codeHint(err.code) && (
              <p className="muted">{codeHint(err.code)}</p>
            )}
          </div>
        )}
      </form>
    </section>
  );
}
